import { FlapComponent } from "../common/FlapComponent";
import { closedFlapBackground, openFlapBackground } from "../common/constants";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

import ClosedFlapButton from "../common/ClosedFlapButton";

import React from "react";

import ClosedFlapTitle from "../common/ClosedFlapTitle";

import FirmnessSelector from "./FirmnessSelector";
import { setCurrentStepSingleSleeperMattressBuilder } from "../../../../redux/slices/customNavigation";
import ReactGA from "react-ga";

const FirmnessPreference = ({ currentStepSingleSleeperMattressBuilder }) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const index = 4;
  return (
    <FlapComponent
      index={3}
      currentStep={currentStepSingleSleeperMattressBuilder}
      styles={{
        background:
          currentStepSingleSleeperMattressBuilder === index
            ? openFlapBackground
            : closedFlapBackground,
      }}
    >
      {currentStepSingleSleeperMattressBuilder !== index && (
        <ClosedFlapButton
          index={3}
          onClick={index => {
            dispatch(setCurrentStepSingleSleeperMattressBuilder(index));
            ReactGA.pageview('/mattress-builder/firmness-preference');
          }}
        >
          <ClosedFlapTitle>{t("4. FIRMNESS PREFERENCE")}</ClosedFlapTitle>
        </ClosedFlapButton>
      )}
      {currentStepSingleSleeperMattressBuilder === index && (
        <FirmnessSelector
          currentStepSingleSleeperMattressBuilder={
            currentStepSingleSleeperMattressBuilder
          }
        ></FirmnessSelector>
      )}
    </FlapComponent>
  );
};

export default FirmnessPreference;
